// extracted by mini-css-extract-plugin
export default {"root":"classes_root__nPXNO","content":"classes_content__JSizj","amount-input":"classes_amount-input__erHOj","tipRow":"classes_tipRow__3-krH"};